import React, {Component, PropTypes} from 'react';
import {Link} from "react-router";
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'COMPONENT/tip'
import {resultTip, language, errorShow} from 'UTIL/common'
import userService from 'SERVICES/ella/userService'
import {hex_md5} from 'UTIL/md5'
export default class AdministratorsAdd extends Component {
    constructor(props) {
        super(props);
        this.btnSubmit = this.btnSubmit.bind(this);
        this.state = {
            s_county: "",
        };
    }
    componentDidMount() {
        var scrollFunc=function(e){
            e=e || window.event;
            if(e.wheelDelta){//IE/Opera/Chrome
                $("#laydate_box").hide()
            }else if(e.detail){//Firefox
                $("#laydate_box").hide()
            }
        }
        /*注册事件*/
        if(document.addEventListener){
            document.addEventListener('DOMMouseScroll',scrollFunc,false);
        }
        window.onmousewheel=document.onmousewheel=scrollFunc;
        setTimeout("_init_area()", 200);
    }

    btnSubmit(event) {
        event.preventDefault();
        var merchantName = $("#merchantName").val();
        var contactName = $("#contactName").val();
        // var contactTelephone = $("#contactTelephone").val();
        var loginName = $("#loginName").val();
        var password = $("#password").val();
        var address = $("#address").val();
        var regionProvice = $("#s_province").val();
        var regionCity = $("#s_city").val();
        var regionCounty = $("#s_county").val();
        var remark = $("#remark").val();
        $('input[id="roleType"]:checked').each(function () {
            chk_value.push($(this).val());
        });
        var json = {
            merchantName: merchantName,
            contactName: contactName,
            // contactTelephone: contactTelephone,
            loginName : loginName,
            password : password == ''?'':hex_md5(password).toUpperCase(),
            province: regionProvice,
            city: regionCity,
            area: regionCounty,
            address: address,
            remark:remark,
        };
        var errorMessage = '';
        var ids = ['merchantName', 'contactName', 'address', 'loginName', 'password'];
        for (let i in ids) {
            if (json[ids[i]] == '') {
                errorMessage = '信息未填写！';
                errorShow(ids[i], errorMessage);
            }
        }
        if (regionProvice == "省份" ||regionCity == "地级市" || regionCounty == "市、县级市") {
            errorMessage = '信息未填写！';
            $("#error_region").html(errorMessage);
            $("#error_region").attr("name","error");
            $("#error_region").parent().attr("class","errmsgtop");
            $("#error_region").siblings().attr("class","triangle-down");
        }
        if (loginName.length != 11) {
            errorMessage = '请输入正确的手机号！';
            $("#error_loginName").html(errorMessage);
            $("#error_loginName").attr("name","error");
            $("#error_loginName").parent().attr("class","errmsgtop");
            $("#error_loginName").siblings().attr("class","triangle-down");
        }
        let regx =/^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,26}$/;
        if (password.match(regx)==null) {
            errorMessage = '请输入正确的密码格式！';
            $("#error_password").html(errorMessage);
            $("#error_password").attr("name","error");
            $("#error_password").parent().attr("class","errmsgtop");
            $("#error_password").siblings().attr("class","triangle-down");
          return;
        }
        if (errorMessage == '') {
            var data = JSON.stringify(json);
            userService.addBusiness({data}).then(body => {
                console.log(body)
                resultTip(body, '/ella/user/user/businessList');
            })
        }

    }
    areaChange() {
        $("#error_address").html('');
        $("#error_address").attr("name","success");
        $("#error_address").parent().attr("class","");
        $("#error_address").siblings().attr("class","");
        console.log($("#s_county").val());

}
accuracyCheck2(_this) {
    var value = _this.target.value;
    if (value.length == 1) {
        value = value.replace(/[^1-9]/g, '')
    }
    else {
        value = value.replace(/\D/g, '')
    }
    var id = _this.target.id;
    $("#" + id).val(value.substring(0,11));
}
passwordCheck(_this){
    var value = _this.target.value;
        value = value.replace(/[^A-Za-z0-9]/g, '')
    var id = _this.target.id;
    $("#" + id).val(value.substring(0,26));
}

    render() {
        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['userManage']}
                        <small>{language()['businessAdd']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['businessAdd']}</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <form id="micaFrom" className="form-horizontal">
                                <FormInput name="businessName" id="merchantName"/>
                                <FormInput name="contacts" id="contactName"/>
                                {/* <FormInput name="contactTelephone" id="contactTelephone"/> */}
                                <input type="hidden" id="addressVal" defaultValue={this.state.s_county}/>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()["region"]}</label>
                                    <div className="col-xs-6">
                                        <select id="s_province" style={{height: "34px", width: "125px"}}
                                                name="s_province"></select>
                                        <select id="s_city"style={{height: "34px", width: "125px",marginLeft:"10px"}}
                                                name="s_city"></select>
                                        <select id="s_county"  name="s_county"style={{height: "34px", width: "125px",marginLeft:"10px",}}
                                                onChange={this.areaChange.bind(this)}></select>
                                    </div>
                                    <span className = "">
                                            <span id="error_region"  name="success" ></span>
                                            <span className = ""></span>
                                    </span>
                                        <p className="form-control-static text-danger">
                                            <span style={{fontSize: "20px"}}>*</span>
                                        </p>
                                </div>
                                <FormInput name="addressDetail" id="address"/>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()['APPAccount']}</label>
                                    <div className="col-xs-3">
                                        <input type="text" className="form-control"  placeholder='请输入正确手机号码' id='loginName' onKeyUp={this.accuracyCheck2.bind(this)} />
                                    </div>
                                    <span className="">
                                        <span id="error_loginName" name="success"></span>
                                        <span className=""></span>
                                    </span>
                                    <p className="form-control-static text-danger">
                                        <span style={{fontSize: "20px"}}>*</span>
                                    </p>
                                </div>
                                <div className="row form-group">
                                    <label className="multi-label control-label col-xs-2">{language()['APPPassword']}</label>
                                    <div className="col-xs-3">
                                        <input type="text" className="form-control"  placeholder='密码为6-26位字母和数字组合'  id='password' onKeyUp={this.passwordCheck.bind(this)}/>
                                    </div>
                                    <span className="">
                                        <span id="error_password" name="success"></span>
                                        <span className=""></span>
                                    </span>
                                    <p className="form-control-static text-danger">
                                        <span style={{fontSize: "20px"}}>*</span>
                                    </p>
                                </div>
                                <div className="row form-group">
									<label  className="multi-label control-label col-xs-2">{language()['remark']}</label>
									<div className="col-xs-3">
										<textarea className="form-control" rows="3" id="remark"></textarea>
									</div>
								</div>
                            </form>
                        </div>
                        <div className="box-footer">
                            <div className="col-xs-2"></div>
                            <div className="col-xs-1 text-center">
                                <a className="btn btn-success" onClick={this.btnSubmit}>{language()['submit']}</a>
                            </div>
                            <div className="col-xs-1 text-center">
                                <Link to='/ella/user/user/businessList' className="btn btn-default btn-md">
                                    {language()['return']}
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/user/businessAdd.js